import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { RULES } from './auth/Roles';
import { decode } from 'jsonwebtoken';
import { LoginProvider } from './providers/login.provider';
import { LocalStorage } from './wrappers/LocalStorage';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private loginService: LoginProvider,
        private localStorage: LocalStorage,
        private router: Router,
        public toastr: ToastsManager,
        private authService: AuthService,
    ) { }


   generateGuards (resource: string, method: string)  {
        return Object.keys(RULES)
             .filter(guard => RULES[guard].resources[resource]
                && RULES[guard].resources[resource].includes(method))
      }

   async canActivate(route: ActivatedRouteSnapshot) {
        if (this.loginService.isLoggedIn()) {
            // check if user is logged with new user structure
            if(!this.localStorage.retrieve('login-reset-v6')){
                this.localStorage.persist('login-reset-v6', 'true');
                this.localStorage.persist('user', null);
                window.location.href = '/login';
            }

            const user = this.localStorage.retrieve('user');
            const decoded = decode(user.token);
            const path = route.parent.routeConfig ? route.parent.routeConfig.path : route.routeConfig.path
            const method = route.data.method || "full";

            if (route.data && route.data.blocked === true) {
                this.toastr.warning('Esta funcionalidade está bloqueada.', 'Acesso negado');
                this.router.navigateByUrl('/home');
                return false;
            }

            let currentGuards =  this.generateGuards(path, method);
            if((new Date().getTime() / 1000) > decoded.exp){
                const response = await this.authService.refreshToken({username: user.username});
                if(response.success) {
                    this.localStorage.save(response.user,'user')
                } else {
                    this.toastr.warning('Por Favor, faça login novamente!')
                    this.localStorage.persist('user', null);
                    window.location.href = '/login';
                    return false;
                }
            }
            if (currentGuards.length > 0 && !currentGuards.includes(user.permission)){
                this.toastr.warning('Você precisa de permissão para acessar esta página.', 'Acesso negado');
                this.router.navigateByUrl('/home');

                return false;
            }

            return true;
        }
        this.localStorage.persist('login-reset-v6', 'true');
        this.router.navigateByUrl('/login');
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/AuthGuard.ts